<template>
  <div
    class="content has-text-centered"
    :class="{ 'direction-rtl': Language == 'fa' || Language == 'ar' }"
  >
    <div
      class="modal"
      :class="{ 'is-active': vloadPromo.modalActive }"
      id="vloadPromoModal"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <button
            class="delete custom-delete"
            @click="vloadPromo.modalActive = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="vload-promo-steps-content">
            <div class="columns">
              <div
                class="column is-8 has-text-left-desktop has-text-left-tablet"
                v-html="$t('deposit_page_desc')"
              ></div>
              <div class="column">
                <img
                  class="vload-promo-logo"
                  src="../../assets/img/promo/vload/vload-logo.svg"
                />
              </div>
            </div>

            <div class="columns">
              <div class="column is-8 has-text-white has-text-weight-bold">
                <p class="has-text-left is-size-6 custom-mt">{{ $t('deposit_page_desc1') }}</p>
                <div class="columns">
                  <div class="column">
                    <img
                      width="50%"
                      src="../../assets/img/promo/vload/account.svg"
                    />
                    <p class="vload-promo-step">{{ $t('create_new_account') }}</p>
                  </div>
                  <div class="column">
                    <img
                      width="50%"
                      src="../../assets/img/promo/vload/evoucher.svg"
                    />
                    <p class="vload-promo-step">{{ $t('successfully_purchase_vload') }}</p>
                  </div>
                  <div class="column">
                    <img
                      width="50%"
                      src="../../assets/img/promo/vload/tier2.svg"
                    />
                    <p class="vload-promo-step">{{ $t('upgrade_to_tier_2') }}</p>
                  </div>
                </div>
              </div>
              <div class="column">
                <a
                  target="_blank"
                  href="https://vload.expert/register?_referral=nkwwci6z96ytgm4qj9cx"
                  class="vload-promo-register-btn is-size-6-desktop is-size-7-tablet is-size-8-mobile"
                >{{ $t('register_now') }}</a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <new-terms-modal
      v-if="User.info"
      :user-id="User.info.ID"
    ></new-terms-modal>

    <transition
      appear
      name="fadeside"
      mode="out-in"
    >
      <div
        v-if="step == 1"
        key="images"
      >
        <div class="tile is-ancestor">
          <div class="tile is-12 is-vertical">
            <div class="tile is-parent is-unselectable">
              <article class="tile is-parent is-12 is-paddingless has-text-left">
                <h3 class="clear-margin">{{ $t('select_payment_method').tUpper() }}</h3>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child">
                <div class="columns is-multiline pmethods">
                  <div
                    class="column is-3"
                    v-if="checkPSP(img, name)"
                    v-for="(img, name) in paymentImages"
                    @click="selectPaymentMethod(name)"
                    :key="img.PSPName"
                  >
                    <div class="box">
                      <img
                        v-if="name==='bankwire' && Language=='it'"
                        :src="img.pathIT"
                      />
                      <img
                        v-else
                        :src="img.path"
                      />
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>

      <div
        class="tile is-ancestor form-container"
        v-if="step == 2"
        key="component"
      >
        <div class="tile is-12 is-parent">
          <div
            class="tile is-11 is-parent"
            v-if="selected.paymentMethod == name"
            v-for="(img, name) in paymentImages"
            :key="name"
          >
            <div class="tile is-3">
              <figure class="image is-100x100">
                <img
                  v-if="name==='bankwire' && Language=='it'"
                  :src="img.pathIT"
                />
                <img
                  v-else
                  :src="img.path"
                />
              </figure>
            </div>

            <div class="tile is-9">
              <div>
                <span
                  class="title"
                  :class="{ 'has-text-right': Language == 'fa' || Language == 'ar', 'has-text-left': Language != 'fa' && Language != 'ar' }"
                >{{ $t(img.T) }}</span>

                <article class="tile is-child psp">
                  <component
                    :selected="selected"
                    v-bind:is="paymentImages[selected.paymentMethod].Component"
                    :apm="img.Component != name ? name : null"
                  ></component>
                </article>
              </div>
            </div>
          </div>

          <div class="tile is-1">
            <div class="topNav">
              <a
                class="button"
                @click="step--, (selected.paymentMethod = '')"
              >
                <span class="icon is-small">
                  <i
                    class="fa fa-chevron-circle-left"
                    :class="{ 'ml-10': Language == 'fa' || Language == 'ar' }"
                  ></i>
                </span>
                <span>{{ $t('back') }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <a
      class="vload-ref-link"
      v-if="selected.paymentMethod == 'vload'"
      @click="vloadPromo.modalActive = true"
    >
      <img
        width="800px"
        src="../../assets/img/promo/vload/vload-promo-banner.png"
      />
    </a>
  </div>
</template>

<script>
// import RegularPay from './deposit-methods/RegularPay'
// import EpayPro from './deposit-methods/EpayPro'
// import EData from './deposit-methods/EData'
import Skrill from './deposit-methods/Skrill'
import Neteller from './deposit-methods/Neteller'
import Bitcoin from './deposit-methods/Bitcoin'
// import KoalaPay from './deposit-methods/KoalaPay'
// import PagoCUP from './deposit-methods/PagoCUP'
// import Fasapay from './deposit-methods/Fasapay'
import BankWire from './deposit-methods/BankWire'
// import VLoad from './deposit-methods/VLoad'
import Lydiax from './deposit-methods/Lydiax'
import SafeCharge from './deposit-methods/SafeCharge'
import PowerCash from './deposit-methods/PowerCash'
import Payneteasy from './deposit-methods/Payneteasy'
import Mulix from './deposit-methods/Mulix'
import { service } from '../../app'
import { mapActions, mapGetters } from 'vuex'
import api from '../../api'
import config from '../../config'

import NewTermsModal from '../../components/NewTermsModal'

const imgPath = require.context('../../assets/img/funding', true)

export default {
  props: ['platformImages'],
  components: {
    // RegularPay,
    // EpayPro,
    // EData,
    Skrill,
    Neteller,
    Bitcoin,
    // KoalaPay,
    // PagoCUP,
    // Fasapay,
    BankWire,
    // VLoad,
    Lydiax,
    SafeCharge,
    PowerCash,
    NewTermsModal,
    Payneteasy,
    Mulix,
  },
  data() {
    return {
      selected: {
        paymentMethod: '',
      },
      step: 1,
      paymentImages: {},
      currencySymbols: config.currencies,
      vloadPromo: {
        modalActive: false,
      },
    }
  },
  watch: {
    'selected.paymentMethod'() {
      if (this.selected.paymentMethod) {
        this.step = 2
      }
    },
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
      Finance: 'finance/all',
    }),
  },
  mounted() {
    // check for preselected values
    if (this.Finance.deposit.selected.paymentMethod) {
      this.selected.paymentMethod = this.Finance.deposit.selected.paymentMethod
      this['finance/preSelectedDepositValue']({ key: 'paymentMethod', value: null })
    }

    this.$bus.$on('RequestDeposit', this.requestDeposit)
    this.$bus.$on('CheckDeposit', this.checkDeposit)
    // update wallet
    api.GetWallet()
    if (!this.User.TA.length) {
      // get trading accounts if needed
      api.GetTradingAccounts()
    }

    // PSPs (handling image loading/path)
    this.paymentImages = Object.assign({}, this.Finance.PSPs)
    let platNames = Object.keys(this.paymentImages)
    for (let i = 0, l = platNames.length; i < l; i++) {
      this.paymentImages[platNames[i]]['path'] = imgPath('./' + platNames[i] + '.svg', true)
      if (platNames[i] === 'bankwire') {
        this.paymentImages[platNames[i]]['pathIT'] = imgPath('./' + platNames[i] + '-it.svg', true)
      }
    }
  },
  beforeDestroy() {
    this.$bus.$off('RequestDeposit', this.requestDeposit)
    this.$bus.$off('CheckDeposit', this.checkDeposit)
  },
  methods: {
    selectPaymentMethod(name) {
      if (name === 'e-data') {
        this.$toasted.info(this.$t('deposit_info'), { duration: 10000 })
        return
      }

      // if (name === 'bankwire') {
      // 	this.$toasted.info('The bank wire transfer option is temporarily unavailable. Please select another deposit method until a new payment service provider is made available for sending wires.<br><br>We will make all efforts to offer you an alternative bank wire transfer solution as soon as possible.<br><br>We apologize for the inconvenience and greatly appreciate your patience and understanding.<br><br>On the other hand, we have now made available, what we feel is a much more viable alternative solution:<br><br>We have now set up a faster way for you to deposit and withdraw through our KoalaPay Payment Service Provider, without the hassle of the account set up process, as we can take care of setting up the account on your behalf.<br><br>Please send an email to backoffice@eurotrader.eu for more details.', { duration: 100000 })
      // 	return
      // }

      this.selected.paymentMethod = name
    },
    checkPSP(img, name) {
      if (!this.User.wallet.currency) {
        return false
      }

      if (!img.BlockedCurrencies && !img.BlockedCountries) {
        return true
      }

      let PSPCurrencyAllowed = !img.BlockedCurrencies || !img.BlockedCurrencies.length || img.BlockedCurrencies.indexOf(this.User.wallet.currency.toUpperCase()) === -1
      let PSPCountryAllowed = !img.BlockedCountries || !img.BlockedCountries.length || img.BlockedCountries.indexOf(this.User.info.country_code.toUpperCase()) === -1

      if (img.Component == 'mulix') {
        let mulixTesters = [1, 44831, 45267, 48739]
        if (mulixTesters.includes(this.User.info.ID)) {
          return PSPCurrencyAllowed && PSPCountryAllowed
        } else if (name == 'mulix-payretailers') {
          return PSPCurrencyAllowed && PSPCountryAllowed
        } else {
          return false
        }
      }

      return PSPCurrencyAllowed && PSPCountryAllowed
    },
    requestDeposit(url, data, successcb, failedcb) {
      this['logoLoader/set'](true)
      service
        .post(url, data)
        .then(response => {
          if (!response.data.success) {
            this['logoLoader/set'](false)
          }
          successcb(response)
        })
        .catch(error => {
          this['logoLoader/set'](false)
          failedcb(error)
        })
    },
    checkDeposit(id) {
      // this['logoLoader/set'](true)
      service
        .get('/finance/deposit/status/' + id)
        .then(response => {
          if (response.data) {
            if (response.data != 'requested') {
              this.$router.push('/' + (this.Language || 'en') + '/finance/payment-history')
            }
          }
        })
        .catch(error => {
          this.$toasted.error(error)
        })
    },
    ...mapActions(['logoLoader/set', 'finance/preSelectedDepositValue']),
  },
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/initial-variables';
@import '../../assets/css/variables';

.toasted-container .toasted {
  max-width: 480px !important;
  padding: 20px 30px !important;
}

.content h1.clear-margin {
  margin-top: 0;
  margin-bottom: 10px;
}

figure {
  margin: 0 auto;
}

.topNav .button {
  margin: 15px 0 0;
}

.is-3 {
  @media screen and (max-width: $tablet) {
    width: 48% !important;
    float: left;
  }
}

.tradingAccounts {
  justify-content: center;
  .column.is-3 {
    cursor: pointer;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    margin: 1%;
    @media screen and (max-width: $tablet) {
      width: 48% !important;
    }
  }
  p {
    margin: 0;
    font-size: 14px;
    &.title {
      margin: 10px 0 0;
      font-size: 16px;
      font-weight: 700;
    }
  }
}

.methodTradingAccountPreview {
  opacity: 0.9;
  margin-right: 10px;
  border: 1px solid #ccc;
  padding: 0 5px;
  > img {
    max-height: 20px;
    vertical-align: middle;
  }
  > span {
    font-size: 18px;
    font-weight: 700;
  }
  > p {
    font-size: 10px;
    line-height: 1;
    text-align: center;
  }
}

.methodImgPreview {
  > figure,
  > span {
    vertical-align: middle;
    display: inline-block;
  }
  > figure {
    margin-right: 15px;
  }
  text-align: left;
}

.pmethods {
  .box {
    cursor: pointer;
    border: 1px solid #a4a3c7;
    box-shadow: none;
    &:hover {
      border: 1px solid #6826f4;
    }

    img {
      max-width: 171px;
      max-height: 150px;
    }
  }
}

.fadeside-enter-active {
  transition: all 0.2s;
}
.fadeside-leave-active {
  transition: all 0.2s;
}
.fadeside-enter {
  opacity: 0;
  // -webkit-transform: translate3d(-100%, 0, 0);
  // transform: translate3d(-100%, 0, 0);
}
.fadeside-leave-to {
  opacity: 0;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

.field.amount {
  margin-top: 20px;
  float: right;
}
article.psp.tile {
  max-width: 700px;
  margin: 0 auto !important;
}

.form-container {
  margin: 0 !important;
  border: solid $secondary 3px;
}

span.title {
  font-weight: 500;
  font-size: 1.5rem;
  margin-top: 10px;
  text-align: left;
  display: block;
}
p.subtitle {
  font-size: 1rem;
}

a.vload-ref-link {
  margin-top: 30px;
  display: block;
}

.delete.custom-delete {
  background-color: $primary;
}

#vloadPromoModal.modal {
  .modal-background {
    background-color: #2e2a2b99;
  }
  .modal-card {
    width: 950px;
    @media screen and (max-width: 1024px) {
      width: 700px;
    }
    @media screen and (max-width: 768px) {
      width: 350px;
    }
  }
  .modal-card-head {
    border-bottom: 0px;
    background: transparent;
  }
  .modal-card-body {
    flex-grow: 0;
    -webkit-flex-grow: 0;
    background-color: #2e2a2b;
    .vload-promo-steps-content {
      line-height: 1.4rem;
      padding: 15px 40px 15px 40px;
      border: solid 2px #d4c25a;
      font-family: 'Montserrat', sans-serif;
      color: #d4c25a;
      .vload-promo-register-btn {
        background-color: #d4c25a;
        color: #2e2a2b;
        display: block;
        padding: 10px 10px 10px 10px;
        width: 80%;
        margin: 80% 10% 10% 10%;
        border-radius: 5px;
        font-weight: 900;
        @media screen and (max-width: 1024px) {
          margin: 130% 10% 10% 10%;
        }
        @media screen and (max-width: 768px) {
          margin: 10% 10% 10% 10%;
        }
      }
      .vload-promo-logo {
        width: 70%;
        margin-top: 5%;
        @media screen and (max-width: 768px) {
          width: 40%;
        }
      }
      .vload-promo-large-text {
        line-height: 3.2rem;
        @media screen and (max-width: 768px) {
          line-height: 2.5rem;
        }
      }
      .vload-promo-step {
        font-size: 15px;
      }
      .custom-mt {
        margin-top: 10%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Deposit.vue?040b371a